<template>
  <div class="switch-container">
    <div class="switch-track">
      <div class="switch-thumb" :class="currentPosition" />
      <div class="switch-labels">
        <span class="switch-label" @click="setPosition('left')">{{
          props.leftLabel ?? 'Left'
        }}</span>
        <span class="switch-label" @click="setPosition('center')">{{
          props.centerLabel ?? 'Center'
        }}</span>
        <span class="switch-label" @click="setPosition('right')">{{
          props.rightLabel ?? 'Right'
        }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

export type SwitchPosition = 'left' | 'center' | 'right'
const emit = defineEmits<(event: 'change', position: SwitchPosition) => void>()

const props = defineProps<{
  leftLabel?: string
  centerLabel?: string
  rightLabel?: string
}>()

const currentPosition = ref('center')

function setPosition(position: SwitchPosition) {
  currentPosition.value = position
  emit('change', position) // Emit the new position to the parent component if needed
}
</script>

<style scoped>
.switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem;
}

.switch-track {
  position: relative;
  width: 15rem;
  height: 2.5rem;
  background-color: #e0e0e0;
  border-radius: 999px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
}

.switch-thumb {
  position: absolute;
  top: 0px;
  width: 33%;
  height: 100%;
  background-color: white;
  border-radius: 999px;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.switch-thumb.left {
  left: 0px;
}

.switch-thumb.center {
  left: 33%;
}

.switch-thumb.right {
  left: 66%;
}

.switch-labels {
  width: 100%;
  position: absolute;
  display: flex;
}

.switch-label {
  width: 33%;
  text-align: center;
  cursor: pointer;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
}

.switch-label:hover {
  color: #666;
}
</style>
